// extracted by mini-css-extract-plugin
export default {"icon-container":"NewsTopHeader_icon-container__iy41u","icon-subcontainer":"NewsTopHeader_icon-subcontainer__1N6l9"};